import { render } from "./RegisterKeypad.vue?vue&type=template&id=4a52e469"
import script from "./RegisterKeypad.vue?vue&type=script&lang=js"
export * from "./RegisterKeypad.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__